import type { Step } from '../groupCreation';

import StepList from './StepList';

// The step list plus a success line once the run completes — shown while a creation
// flow is running or after it finishes (success or failure).
export default function CreationStatus({
  steps,
  done,
  successMessage,
}: {
  steps: Step[];
  done: boolean;
  successMessage: string;
}) {
  return (
    <div className="mb-4">
      <StepList steps={steps} />
      {done && <div className="text-success font-bold mt-4 text-sm">{successMessage}</div>}
    </div>
  );
}
